import React from "react";
// import { Helmet } from "react-helmet";
import { Helmet } from "react-helmet-async";

import Section1 from "../includes/AIDevelopment/Section1";
import Section2 from "../includes/AIDevelopment/Section2";
import Section3 from "../includes/AIDevelopment/Section3";
import Section4 from "../includes/AIDevelopment/Section4";
import Section5 from "../includes/AIDevelopment/Section5";
import Section6 from "../includes/AIDevelopment/Section6";
import Section7 from "../includes/AIDevelopment/Section7";
// import Section8 from "../includes/AIDevelopment/Section8";

// form from homepage
import Section9 from "../includes/Home/Section9";

const AIDevelopment = ({ devUrl }) => {

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Service",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://www.exddigital.com/ai-development",
    },
    name: "AI Development Services",
    headline: "Custom AI Solutions to Transform Your Business",
    description:
      "Build scalable AI-powered applications using LLMs, automation, and intelligent systems tailored to your business needs.",
    image: "https://www.exddigital.com/images/exd_digital.webp",
    provider: {
      "@type": "Organization",
      name: "ExD Digital",
      url: "https://www.exddigital.com",
    },
    areaServed: "Worldwide",
    datePublished: "2026-04-20",
    dateModified: "2026-04-20",
  };

  return (
    <>
      <Helmet>
        <title>AI Development Services</title>

        <meta
          name="description"
          content="We build AI-powered applications, LLM solutions, automation systems, and intelligent platforms to help your business scale faster."
        />

        <link
          rel="canonical"
          href="https://www.exddigital.com/ai-development"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="AI Development Services | ExD Digital"
        />
        <meta
          property="og:description"
          content="Custom AI solutions including LLM apps, automation tools, and intelligent systems tailored for your business."
        />
        <meta
          property="og:url"
          content="https://www.exddigital.com/ai-development"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.exddigital.com/images/exd_digital.webp"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="AI Development Services | ExD Digital"
        />
        <meta
          name="twitter:description"
          content="Build scalable AI-powered applications using LLMs, automation, and intelligent systems."
        />
        <meta
          name="twitter:image"
          content="https://www.exddigital.com/images/exd_digital.webp"
        />

        {/* Schema */}
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>

      <main className="our-ai-main">
        <article className="ai-development">

          <Section1 url={devUrl} />
          <Section2 url={devUrl} />
          <Section3 url={devUrl} />
          <Section4 url={devUrl} />
          <Section5 url={devUrl} />
          <Section6 url={devUrl} />
          <Section7 url={devUrl} />
          <Section9 url={devUrl} />
          {/*<Section8 url={devUrl} /> */}

        </article>
      </main>
    </>
  );
};

export default AIDevelopment;